import React from "react";
import Form from "components/Forms/Property";
import { useFormik } from "formik";
import { updateWithEntry } from "ducks/properties";
import { add } from "ducks/toasts";

import { connect } from "react-redux";
import { useRemoveQueryNavigation } from "helpers/hooks/url";
import { useLocation } from "react-router-dom";
const EditProperty = ({ add, updateWithEntry, property }) => {
  const location = useLocation();
  console.log(location);
  console.log(property);

  const onClose = useRemoveQueryNavigation("editProperty");
  const { values, handleSubmit, setFieldValue } = useFormik({
    enableReinitialize: true,
    initialValues: location.state ?? property,
    onSubmit: values => {
      updateWithEntry(values);
      add(
        "Update erfolgreich",
        "Benutzer wurde erfolgreich aktualisiert",
        "success",
        "user"
      );
    }
  });

  return values ? (
    <Form
      subtitle="Datensatz bearbeiten"
      values={values}
      handleChange={setFieldValue}
      handleSubmit={handleSubmit}
      handleClose={onClose}
    ></Form>
  ) : (
    false
  );
};

export default connect(
  (state, { id }) => ({ property: state.properties.items[id] }),
  { updateWithEntry, add }
)(EditProperty);
